import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { MitigationSectionViewProps } from ".";
import { MitigationSouresType } from "../../../../../../constants/constants";

const SourceSection = (props: MitigationSectionViewProps) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbInternal")}
                    >
                        {
                            props.data?.sources && props.data?.sources.filter(p => p.type === MitigationSouresType.Internal).map((item, index) => (
                                <span key={index}>
                                    {item.name}
                                </span>
                            ))
                        }

                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbExternal")}
                    >
                        {
                            props.data?.sources && props.data?.sources.filter(p => p.type === MitigationSouresType.External).map((item, index) => (
                                <span key={index}>
                                    {item.name}
                                </span>
                            ))
                        }

                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default SourceSection;